import React from 'react';
import Upload from "../UI/upload/upload";

const UploadDocuments = () => {
  return (
    <div className={` w-full flex flex-col gap-5 md:grid md:grid-cols-4 md:gap-10  justify-center items-center md:items-start`}>
      <Upload title={" Reg"} name={"Reg"}/>
      <Upload title={" CDC"} name={"CDC"}/>
      <Upload title={" Passport"} name={"Passport"}/>
      <Upload title={"Pic 3*4"} name={"3*4"}/>
    </div>
  );
};

export default UploadDocuments;
